import React, { Fragment, useMemo } from 'react'
import { withTranslation } from 'react-i18next'

const PrivacyStatement = ({ t, i18n }) => {
  const para1Information = useMemo(() => {
    if (i18n.language === 'en') {
      return (
        <Fragment>
          {t('privacy_notice.para1_motor_vehicle_act')}
          {t('privacy_notice.para1_motor_vehicle_act_cont')}
          {t('privacy_notice.para1_foipop')}
          {t('privacy_notice.para1_foipop_cont')}
        </Fragment>
      )
    }

    return (
      <Fragment>
        <i lang="en">{t('privacy_notice.para1_motor_vehicle_act')}</i>
        {t('privacy_notice.para1_motor_vehicle_act_cont')}
        <i lang="en">{t('privacy_notice.para1_foipop')}</i>
        {t('privacy_notice.para1_foipop_cont')}
        <i lang="en">{t('privacy_notice.para1_foipop_abbreviated')}</i>
        {t('privacy_notice.para1_foipop_abbreviated_cont')}
      </Fragment>
    )
  }, [i18n.language])

  return (
    <div>
      <h2>{t('privacy_notice.page_title')}</h2>
      <p>
        {t('privacy_notice.para1')}
        {para1Information}
      </p>
      <p>
        {t('privacy_notice.para2')}
        <a
          target="_blank"
          rel="noopener noreferrer"
          href={i18n.language === 'en' ? 'https://beta.novascotia.ca/privacy' : 'https://beta.novascotia.ca/fr/enonce-de-confidentialite'}
        >
          {' '}
          {t('privacy_notice.privacy_statement_link')}
          <span className="ns-visually-hidden">{t('shared.opens_new_tab')}</span>
        </a>
        .{t('privacy_notice.para3')}
        <a href="mailto:askus@novascotia.ca">{t('privacy_notice.ask_novascotia')}</a>.
      </p>
    </div>
  )
}

export default withTranslation('common')(PrivacyStatement)
